/** Admin Home Dashboard block permission keys from GET /permission/get/:role_id. */
export const ADMIN_HOME_DASHBOARD_PERMISSION_KEYS = {
  PARTNER_PROGRAM: "admin_partner_program",
  PS_REVENUE: "ps_revenue",
} as const;

export type AdminHomeDashboardPermissionKey =
  (typeof ADMIN_HOME_DASHBOARD_PERMISSION_KEYS)[keyof typeof ADMIN_HOME_DASHBOARD_PERMISSION_KEYS];
